<template>
  <div class="logout-wrapper">
    <WithLoader :isLoading="isAuthLoading" classType="primary"></WithLoader>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import withNavigate from "@/mixins/withNavigate";
import WithLoader from "@/components/WithLoader";

export default Vue.component("Logout", {
  metaInfo: {
    title: "Logout"
  },

  mixins: [withNavigate],
  components: {
    WithLoader
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("dashboard", ["resetDashboard"])
  },

  computed: {
    ...mapGetters("auth", ["isAuthLoading"])
  },

  created() {
    this.logout(() => {
      this.resetDashboard();
      this.navigate("/login");
    });
  }
});
</script>

<style lang="scss" scoped>
.logout-wrapper {
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 55;
  background: white;
}
</style>
